import {ChangeDetectionStrategy, Component} from "@angular/core";
import {HeaderComponent} from "../../components/header/header.component";
import {ForgottenPasswordFormComponent} from "../../components/forgotten-password-form/forgotten-password-form.component";

@Component({
  selector: "app-forgotten-password",
  templateUrl: "./forgotten-password.component.html",
  styleUrls: ["./forgotten-password.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, ForgottenPasswordFormComponent],
})
export class ForgottenPasswordComponent {}
